const starts = '2027-03-03T16:00:00-07:00' // 4:00 PM MST on Wednesday before for APAC

// NOTE: the conference generally ends at 6:00 PM MST on Saturday but stays up for Japan until 7:00 AM MST on Sunday.
const ends = '2027-03-06T18:00:00-07:00'

const inPersonStarts = '2027-03-04T08:00:00-07:00' // 8:00 AM MST on Thursday, March 4
const inPersonEnds = '2027-03-06T17:00:00-07:00' // 5:00 PM MST on Saturday

const enableDashboard = '2026-09-01T06:00:00.000Z'
const boothDeadline = '2027-02-18T07:00:00.000Z'
const attachmentsEditDeadline = '2027-02-22T05:59:59.000Z'
const preEventStart = '2026-02-25T07:00:00.000Z'
const syllabiAvailable = '2027-02-25T09:00:00-07:00' // Syllabi are available a week before the conference opens.
const mainStageUploadDeadlineTimestamp = '2027-03-01T07:00:00.000Z' // 11:00 PM MST on the Monday before the conference

const startDate = new Date(starts)
const startYear = startDate.getFullYear().toString()
const startTimestamp = startDate.getTime()
const endTimestamp = new Date(ends).getTime()

const conferenceConfig = {
  starts,
  ends,
  startYear,
  startTimestamp,
  endTimestamp,
  enableDashboard,
  boothDeadline,
  preEventStart,
  attachmentsEditDeadline,
  mainStageUploadDeadlineTimestamp,
  preview: {
    redirects: {
      on: 'https://www.familysearch.org/en/labs/on/SFKY5GXKYPVHF0QZM04GV',
      off: 'https://www.familysearch.org/en/labs/off/SFKY5GXKYPVHF0QZM04GV',
    },
  },
  resources: {
    downloadable: {
      syllabi: syllabiAvailable,
      // Available when the conference starts at the presenters discretion.
      slides: starts,
    },
  },
  inPerson: {
    starts: inPersonStarts,
    ends: inPersonEnds,
  },
}

export default conferenceConfig
